import { useState } from 'react';
import { IHsnData } from '../Service/hsn.service';
interface IResultMobileProps {
  ele: IHsnData;
}

export const ResultMobile = ({ ele }: IResultMobileProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b-2 pb-4">
      <div onClick={() => setIsOpen(!isOpen)}>
        <div className="content-center flex place-content-between mt-2">
          <span
            className="font-medium text-s-14"
            dangerouslySetInnerHTML={{ __html: ele.description }}
          />
          <div className="self-center">
            <svg
              width="10"
              className={`${isOpen ? 'rotate-180' : 'rotate-0'} `}
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.83712 5.5028C1.16307 5.82646 1.68939 5.82553 2.0142 5.50072L5.24336 2.27156L8.48054 5.50169C8.80529 5.82573 9.33115 5.82544 9.65554 5.50104C9.98019 5.1764 9.98019 4.65005 9.65554 4.3254L5.83262 0.502481C5.50718 0.177044 4.97954 0.177044 4.65411 0.502481L0.835034 4.32155C0.508602 4.64799 0.509537 5.17752 0.83712 5.5028Z"
                fill="#9092A3"
              />
            </svg>
          </div>
        </div>
        <div className="mt-2 ">
          <span className="font-medium text-s-14">HSN code:</span>
          <span className="font-bold text-s-14"> {ele.hsnCode}</span>
        </div>
        <div>
          <span className="font-medium text-s-14">CESS: {ele.cess}</span>
        </div>
      </div>
      {isOpen ? (
        <div className="flex mt-2 flex place-content-between">
          <div className="flex-col">
            <p className="text-s-12">Rate (%)</p>
            <p className="text-s-14">{ele.rate}</p>
          </div>

          <div className="flex-col">
            <p className="text-s-12"> Effective Date</p>
            <p className="w-10 text-s-14">{ele.effectiveDate}</p>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
